import React from 'react';
import { WarningTriangle } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/section-error.css';
import PropTypes from 'prop-types';

// method to add section titles from an errors array
// to the passed in array of titles, if the title is not yet present
const addNewSectionTitles = (errors, sectionTitles) => {
  errors.forEach((error) => {
    const { sectionTitle } = error;
    if (!sectionTitles.includes(sectionTitle)) {
      sectionTitles.push(sectionTitle);
    }
  });
};

const SummaryError = React.memo(({
  errors,
}) => {
  const {
    inlineErrors,
    modalErrors,
  } = errors;
  // Extract a list of section titles where the section has errors
  const sectionTitles = [];
  addNewSectionTitles(inlineErrors, sectionTitles);
  addNewSectionTitles(modalErrors, sectionTitles);

  return (
    <div className="section-error-wrapper summary-error-wrapper">
      <div className="section-error">
        <div className="warning-svg-wrapper">
          <div className="warning-svg">
            <WarningTriangle />
          </div>
        </div>
        <div className="error-message">
          <p>
            The following sections have fields that need your attention
          </p>
          {
            sectionTitles && sectionTitles.length > 0 && (
              <ul className="errors">
                {
                  sectionTitles.map((title, index) => (
                    <li
                      key={title}
                    >
                      {title}
                    </li>
                  ))
                }
              </ul>
            )
          }
        </div>
      </div>
    </div>
  );
});

const ApproverPreventError = React.memo(() => (
  <div className="section-error-wrapper summary-error-wrapper">
    <div className="section-error">
      <div className="warning-svg-wrapper">
        <div className="warning-svg">
          <WarningTriangle />
        </div>
      </div>
      <div className="error-message">
        <p>
          Change Management cannot submit for approval until related mobile ticket complete its journey
        </p>
      </div>
    </div>
  </div>
));

// SIA file error warning banner
const SiaImportError = React.memo(({
  getRemedyFailedStatusCR,
}) => (
  getRemedyFailedStatusCR && (
  <div className="section-error-wrapper summary-error-wrapper">
    <div className="section-error">
      <div className="warning-svg-wrapper">
        <div className="warning-svg">
          <WarningTriangle />
        </div>
      </div>
      <div className="error-message-sia">
        <p>Remedy Attachment Upload Failed.</p>
        <p>Please review the SIA report and reupload the file.</p>
      </div>
    </div>
  </div>
  )
));


SummaryError.propTypes = {
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)),
};

SummaryError.defaultProps = {
  errors: {},
};

SiaImportError.propTypes = {
  getRemedyFailedStatusCR: PropTypes.bool,
};

export {
  SummaryError,
  ApproverPreventError,
  SiaImportError,
};
